var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ExpedienteCreateApelacionView',{attrs:{"title":"Nuevo descargo","prefix-create-path":"case_file/discharge/"}})}
var staticRenderFns = []

export { render, staticRenderFns }